<template>
	<v-container fluid fill-height>
		<Artigo :mostrar.sync="abrirArtigo" :artigo.sync="artigo" />
		<v-row class="mx-auto">
			<v-col cols="12">
				<v-card :loading="loadingCard" tile :height="this.$store.getters.alturaContent -70" cols="12" style="overflow-y: auto">
					<v-card-title>
					<v-toolbar flat class="pt-3" dense>
						<v-select :loading="loadingCategoria" dense outlined :items="categorias" v-model="categoria"></v-select>
					</v-toolbar>
					<v-toolbar flat class="pt-3" dense>
						<v-spacer></v-spacer>
						<v-checkbox v-model="pendentes" label="Pendentes"></v-checkbox>
						<v-checkbox class="mx-3" v-model="lidos" label="Lidos"></v-checkbox>
						<v-spacer class="d-sm-none"></v-spacer>
					</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols="12" class="col-sm-6 col-lg-4 col-xl-3" v-for="artigo in artigos" :key="artigo.id">
									<v-hover v-slot:default="{hover}">
										<v-card class="mx-auto" :elevation="hover ? 16 : 2">
											<v-card-title class="primary white--text" dense>
												<h5>{{artigo.titulo}}</h5>
											</v-card-title>
											<v-card-text class="py-4">
												<p>Publicação: {{artigo.data_publicacao}}<br />
												Grau: {{artigo.grau}}º<br />
												Publicado Por: {{artigo.nome_iniciado}}<br />
												Autor: {{artigo.autor}}<br />
												Categoria: {{artigo.nome_categoria}}<br />
												Leitura: {{artigo.status_leitura}}</p>
											</v-card-text>
											<v-card-actions>
												<v-btn @click="lerArtigo(artigo)" text color="primary">Ler texto...</v-btn>
											</v-card-actions>
										</v-card>
									</v-hover>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, showError } from "@/config/global"
	import Artigo from '@/components/estudos/ItemEstudo'
	import Br from '@/config/barramento'
	import axios from 'axios'
	import {mapState} from 'vuex'

	export default{
		name: 'textos',
		computed:{
			... mapState(['buscandoDados', 'user', 'lendoArtigo']),

			
		},
		components: {Artigo},
		data(){
			return{
				loadingCard: false,
				loadingCategoria: false,
				categoria: "0",
				pendentes: true,
				lidos: false,
				
				options: [
					{text: 'Lidos', value: 'lidos'},
					{text: 'Não lidos', valus: 'nlidos'},
					{text: 'Todos', value: 'todos'}
				],
				opcoes: [
					{text: ''}
				],
				artigos: {},
				artigo: {},
				abrirArtigo: false,
				totalPaginas: null,
				itensPorPagina: 8,
				paginaAtual: 1,
				categorias: [

				],
			}
		},
		methods: {

			

			buscarCategorias(){
				const url = `${baseApiUrl}/Cadastros/categorias/read.php`
				this.loadingCategoria = true
				axios(url).then(res => {
					if(res.data.dados){
						this.categorias = res.data.dados.map( c =>{
							return {
								value: c.id, text: c.descricao
							}
						})
						this.categorias.unshift({value: "0", text: 'Todos'})
						
					}
					this.loadingCategoria = false
				})
			},

			carregaTextos(){
				
				this.artigos = {}
				this.loadingCard = true
				
				const url = `${baseApiUrl}/estudos/read.php?grau=${this.user.outros.grauAtual}&ipp=${this.itensPorPagina}&page=${this.paginaAtual}&categoria=${this.categoria}&iniciado=${this.user.iniciado}&lidos=${this.lidos}&pendentes=${this.pendentes}`
				
				axios(url)
					.then(res => {
						this.artigos = res.data.dados.map(art => {
							return{
								...art,
								status_leitura: art.lido == "1" ? 'realizada' : 'pendente'
							}
						})
						
                        this.totalPaginas = res.data.totalPaginas
						
						this.loadingCard = false
					})
					.catch({showError})
					
			},

			lerArtigo(artigo){
				this.artigo = artigo
				this.abrirArtigo = true
			},

			voltar(){
				if(this.$route.params.artigo){
					this.$router.push({name: 'home'})
				}
				this.$store.commit('alteraLendoArtigo', false)
				this.carregaTextos()
			},
		},
		created(){
			
			this.$store.commit('alteraLendoArtigo', false)
			
			Br.onPaginaAlterada(pagina => {
				this.paginaAtual = pagina
			})
			
			if(this.$route.params.artigo){
				this.$store.commit('alteraLendoArtigo', true)
				this.artigo = this.$route.params.artigo
			}else{
				this.buscarCategorias()
				this.carregaTextos()	
			}
			
		},

		watch:{

			pendentes(){
				this.carregaTextos()
			},

			lidos(){
				this.carregaTextos()
			},

			categoria(){
				this.carregaTextos()
			},

			'artigo.status_leitura'(){

				this.carregaTextos()
			}
		}

	}

</script>

<style scoped>

	.estudos{
		height: 100%;
		max-height: 90vh;

		display: flex;
		flex-direction: column;
	}

	.estudos .dados{
		height: 100%;
	}

	.estudos-conteudo{
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		flex-wrap: wrap;
		height: 70vh;
		padding: 10px 4px;
		align-self: center;
		overflow-Y: auto;
	}

	.estudo-card{
		margin: 6px;
		width: 40%;
		height: 40%;
		border-radius: 6px;
		box-shadow: 3px 6px 6px rgba(0,0,0,0.4);
		cursor: pointer;
	}

	.estudo-card-header{
		display: flex;
		align-items: center;
		padding: 4px 10px;
		width: 100%;
		height: 30%;
		margin: 0;
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
		position: relative;
		background-color: var(--cor-secundaria);
	}

	.estudo-card-header .grau{
		width: 40px;
		height: 40px;
		border-radius: 50%;
		border: 2px solid white;
		color: white;
		margin: 4px 10px 4px 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-style: italic;
		font-weight: bold;
	}

	.estudo-card-header > h2{
		position: relative;
		color: rgb(255, 255, 255);
		z-index: 20;
		font-size: .9rem;
	}

	.estudo-card-body{
		width: 100%;
		height: 65%;
		margin: 0;
		padding: 8px;
		background-color: white;
		font-size: 0.7rem;
		display: flex;
		flex-direction: column;
	}

	.estudo-card-footer{
		width: 100%;
		height: 5%;
		margin: 0;
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
		background-color: var(--cor-secundaria);
	}

	
	.estudos .campos{
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.estudos .campos .select-categorias{
        background-color: var(--cor-principal);
        width: 160px;
        margin: 4px;
        color: rgb(255,255,255);
        outline: none;
        border-radius: 12px;
    }

    .estudos .campos .select-categorias:hover{
		background-color: var(--cor-secundaria);	
    }
    

</style>
